
// => Styling
import styles from './GameView.module.css';

// => Data classes
import ClipData from '../../data/ClipData';
import QuestionData from '../../data/QuestionData';
import { ChoiceData } from '../../data/QuestionData';
import GameData from '../../data/GameData';

// => Utils
import {
    findCardByClipId,
    isClipIdUnlocked,
    getBaseClips,
    getXpacClips,
    getAllCards
} from '../../util/Utils';

// => Data
import { prefs } from '../../preferences';

// => Internal components
import DebugMonitor from './components/DebugMonitor';
import OverlayFx from './components/OverlayFx';
import TextPrompt from './components/TextPrompt';
import ChoicesContainer from './components/ChoicesContainer';
import Countdown from './components/Countdown';
import SwipeButton from './components/SwipeButton';
import Controls from './components/Controls';

import Modal from '../../components/Modal';
import Dialog from '../../components/Dialog';

// => 3rd party components
import ReactPlayer from 'react-player';

// => React hooks
import { useEffect, useRef, useState } from 'react';

// => 3rd party hooks
import useStateMachine from '@cassiozen/usestatemachine';
import { useSpring, animated } from 'react-spring';
import { useDrag } from '@use-gesture/react';
import { useKeyboardShortcut } from '../../hooks/useKeyboardShortcut.tsx';

// => Content
import baseClips from '../../content/baseClips.json';
import baseLines from '../../content/baseLines.json';
import baseQuestions from '../../content/baseQuestions.json';
import baseTags from '../../content/tags.json';
import xpacClips from '../../content/xpacClips.json';


// ============
// Component
// ============
const GameView = ({
    data = null,
    onUpdateCockChance = (value) => {},
    onUpdateMasculinity = (value) => {},
    onUpdateSafeTimer = (value) => {},
    requestGameExit = () => {},
    requestSettings = () => {},
    requestFullscreenToggle = () => {},
    fullscreen = false,
    debugMode = false,
    onAddCurrency = (v) => {},
    onRemoveCurrency = (v) => {},
    unlockedCards = [],
}) => {
    
    let initialized = false

    // Refs
    // ---------
    const refVidMain = useRef(null)
    const refVidBg = useRef(null)

    const refAnimFlyOut = useRef(false)

    // States
    // ---------
    const [debugMonitor, setDebugMonitor] = useState(false)
    const [overlayFx, setOverlayFx] = useState(true)

    const [gamePaused, setGamePaused] = useState(false)
    const [gameData, setGameData] = useState(null)

    const [forceLoopOverride, setForceLoopOverride] = useState(false)
    const [activeClip, setActiveClip] = useState(new ClipData())
    const [prevClip, setPrevClip] = useState(new ClipData())
    const [clipTimeCurrent, setClipTimeCurrent] = useState(null)
    const [clipTimeMax, setClipTimeMax] = useState(null)
    const [clipPlaybackRate, setClipPlaybackRate] = useState(1)

    const [prevBabes, setPrevBabes] = useState([])

    const [clipTriggerTime, setClipTriggerTime] = useState(null)
    const [clipTriggerChecked, setClipTriggerChecked] = useState(false)
    const [cockDuration, setCockDuration] = useState(null)
    const [cockTimer, setCockTimer] = useState(null)
    const [cockTriggerChance, setCockTriggerChance] = useState(0)
    const [babeSafeTimer, setBabeSafeTimer] = useState(null)

    const [textPrompt, setTextPrompt] = useState(null)
    const [question, setQuestion] = useState(null)
    const [preventQuestionPromptCleanup, setPreventQuestionPromptCleanup] = useState(false)
    const [countdownTimer, setCountdownTimer] = useState(null)
    const [onCountdownEnded, setOnCountdownEnded] = useState(null)

    const [tauntChance, setTauntChance] = useState(0)
    const [tauntTimer, setTauntTimer] = useState(null)

    const [masculinity, setMasculinity] = useState(0)


    // Left arrow key shortcut
    useKeyboardShortcut({
        key: "ArrowLeft",
        onKeyPressed: () => {},
        onKeyUp: () => {
            if (canSwipe()) {
                //console.log("TEST ArrowLeft!!!")
                swipeOnBabe(-1)
            }
        }
    })
    // Right arrow key shortcut
    useKeyboardShortcut({
        key: "ArrowRight",
        onKeyPressed: () => {},
        onKeyUp: () => {
            if (canSwipe()) {
                //console.log("TEST ArrowRight!!!")
                swipeOnBabe(1)
            }
        }
    })


    // Gamestate machine
    // ---------
    const [gamestate, sendGamestate] = useStateMachine({

        initial: 'pre',

        states: {

            // Init gamestate
            pre: {
                on: {
                    READY: 'startidle'
                },
                effect() {
                    
                    // Enter

                    // TODO: Preprocessing here!
                    if (!initialized) {
                        initialized = true

                        // Manage preferences
                        let prefsDebug = prefs.getPref(prefs.PREF_DEBUG, false)
                        if (prefsDebug !== null) {
                            setDebugMonitor(prefsDebug)
                        }

                        // Check for game data
                        if (data == null) {
                            setGameData(new GameData())
                        } else {
                            setGameData(data)
                        }

                        // TODO: Load mod content
                        // TODO: Validate content

                        // We're ready to start
                        console.log('Game ready. Starting...', gamestate)
                        sendGamestate('READY')
                    }

                    // Exit
                    return () => {
                        // TODO: Processing on exit here!   
                    }
                },
            },

            // Start-idle gamestate
            startidle: {
                on: {
                    CLIPEND: 'startidle',
                    START: 'babe'
                },
                effect({ event }) {
                    // Enter
                    console.log('Entered "startidle" gamestate.', gamestate)

                    // Show random start clip
                    let clip = getRandomClip(baseClips.start, (c) => { return c.id !== prevClip.id })
                    // Allow the same clip be played again
                    if (activeClip.id === clip.id) {
                        refVidMain.current.seekTo(0)
                    } else {
                        setActiveClip(clip)
                    }

                    // This we do only once at startup
                    if (event.type !== 'CLIPEND') {
                        // Show start question
                        let q = chooseQuestion(baseQuestions.system.startQuestion)
                        // Warm-up choice callback
                        /*q.choices[0].onChoice = () => {
                            // TODO TODO TODO
                        }*/
                        // Ready choice callback
                        q.choices[0/*1*/].onChoice = () => {
                            sendGamestate('START')
                        }

                        setQuestion(q)
                    }

                    // Exit
                    return () => {

                        console.log('Exited "startidle" gamestate.', gamestate)
                    }
                },
            },

            // Warm-up gamestate
            // TODO TODO TODO

            // Babe gamestate
            babe: {
                on: {
                    CLIPEND: 'babe',
                    TRIGGER: 'cock',
                    SWIPE: 'babe',
                    BABE: 'babe',
                    COCK: 'cock',
                    GAMEOVER: 'gameover',
                },
                effect({ event }) {
                    // Enter
                    console.log('Entered "babe" gamestate.', gamestate)
                    
                    if (prevClip?.id !== activeClip.id) {
                        setPrevClip(activeClip)
                    }

                    // If our cock chance is too high, there is a set chance to see cock immediately
                    // if we don't forceLoopOverride or have a safe timer active
                    // This is to prevent just swiping on forever
                    if (!forceLoopOverride && babeSafeTimer === null) {
                        // If cock chance is VERY HIGH
                        if (cockTriggerChance >= gameData.defaultCockChancePercentageVeryHigh) {
                            if (getChance(gameData.defaultStaticCockChanceVeryHigh)) {
                                sendGamestate('TRIGGER')
                            }
                        }
                        // If cock chance is HIGH
                        else if (cockTriggerChance >= gameData.defaultCockChancePercentageHigh) {
                            if (getChance(gameData.defaultStaticCockChanceHigh)) {
                                sendGamestate('TRIGGER')
                            }
                        }
                    }

                    // Slide video in
                    springApi.start({
                        from: {
                            x: x
                        },
                        to: {
                            x: 0
                        }
                    })

                    /*  If we came from START event, slow down the video, start a countdown
                        of 5 seconds, display a random "windup" text prompt and resume to normal
                        after the timer ran out. */
                    if (event.type === 'START') {
                        // Remove text prompt and question
                        setPreventQuestionPromptCleanup(true)
                        setQuestion(null)
                        // Setup start countdown things
                        setClipPlaybackRate(gameData.startPlaybackRate)
                        setTextPrompt("Here we go!")  // TODO get random line for that!!!!!!
                        startCountdown(gameData.startCountdown, () => {
                            setTextPrompt(null)
                            setPreventQuestionPromptCleanup(null)
                            setClipPlaybackRate(1)
                        })
                        // Set babeSafeTimer
                        setBabeSafeTimer(gameData.startBabeSafeTimer)
                        // Set cockChance
                        setCockTriggerChance(gameData.startCockChance)
                        // Set taunt chance
                        setTauntChance(gameData.startTauntChance)
                    }
                    
                    // Start the babeSafeTimer if we came from a TIMEOUT event
                    if (event.type === 'TIMEOUT') {
                        setBabeSafeTimer(getRndTime(gameData.defaultBabeSafeTimerMinimum, gameData.defaultBabeSafeTimerMaximum, 1))
                        // Clean up taunts
                        if (question === null) {
                            showTaunt()
                        }
                    }

                    // If we came from swipe event, increase our cock chance if possible
                    if (event.type === 'SWIPE') {
                        if (!clipTriggerChecked) {
                            let percentageViewed = remap(clipTimeCurrent, 0, clipTriggerTime)
                            let increase = 0
                            if (percentageViewed < 1/3) {
                                increase = 3
                            } else if (percentageViewed < 2/3) {
                                increase = 2
                            } else {
                                increase = 1
                            }
                            
                            setCockTriggerChance((prevValue) => prevValue + increase)
                        }
                    }

                    // If we came from a previous babe clip
                    if (event.type === 'CLIPEND') {

                        /*  If we don't have a text prompt displayed currently, check for the
                            chance to display a random taunt */
                        if (textPrompt === null) {
                            if (canTaunt()) {
                                // Get a random babe taunt
                                let taunt = getRandomLine(baseLines.babeTaunts)
                                // Show taunt as text prompt
                                showTaunt(taunt, getRndTime(
                                    gameData.defaultTauntDurationMinimum, 
                                    gameData.defaultTauntDurationMaximum, 
                                    1
                                ))
                            }
                        }

                        // Let chance decide if we should increase the cock chance
                        if (getChance(gameData.defaultCockChanceIncreaseAfterSucessChance)) {

                            let increase = getRndTime(
                                gameData.defaultCockChanceIncreaseAfterSuccessMinimum, 
                                gameData.defaultCockChanceIncreaseAfterSuccessMaximum, 
                                0
                            )
                            setCockTriggerChance((prevValue) => prevValue + increase)
                        }
                    }

                    // Reset cock timer if needed
                    if (cockDuration !== null) {
                        setCockDuration(null)
                        setCockTimer(null)
                    }

                    let clips = baseClips.babes;
                    // Include babes clips from xpacs if we have them unlocked
                    let xpacs = getXpacClips("babes")
                    // Filter xpac clips for unlocked clips only
                    let filteredXpacs = xpacs.filter(x => isClipIdUnlocked(unlockedCards, x.id))
                    clips = clips.concat(filteredXpacs)

                    // Get babe exclude tags from prefs
                    let excludeTags = prefs.getPref(prefs.PREF_TAGS, {
                        exclude: [], only: []
                    }).exclude
                    excludeTags = excludeTags.filter((t) => {
                        return baseTags.babes.filter(b => b.id === t).length > 0
                    })
                    // Get babe only tags from prefs
                    let onlyTags = prefs.getPref(prefs.PREF_TAGS, {
                        exclude: [], only: []
                    }).only
                    onlyTags = onlyTags.filter((t) => {
                        return baseTags.babes.filter(b => b.id === t).length > 0
                    })

                    // Show random babe clip
                    let clip = getRandomClip(clips, (c) => {
                        // filter last played clip
                        let previousClip = c.id !== prevClip.id
                        // filter last 5 babes
                        let previousBabes = prevBabes.filter((d) => {
                            return c.id === d.id
                        }).length === 0
                        return previousClip && previousBabes
                    }, excludeTags, onlyTags) //get tags to filter from prefs

                    // -
                    setActiveClip(clip)

                    // Exit
                    return () => {
                        console.log('Exited "babe" gamestate.', gamestate)
                        addPrevBabe(clip)
                    }
                },
            },

            // Cock gamestate
            cock: {
                on: {
                    CLIPEND: 'cock',
                    TIMEOUT: 'babe',
                    BABE: 'babe',
                    COCK: 'cock',
                    GAMEOVER: 'gameover',
                },
                effect({ event }) {
                    // Enter
                    console.log('Entered "cock" gamestate.', gamestate)

                    if (prevClip?.id !== activeClip.id) {
                        setPrevClip(activeClip)
                    }

                    // Slide video in
                    springApi.start({
                        from: {
                            x: x
                        },
                        to: {
                            x: 0
                        }
                    })

                    // Reset babeSafeTimer because obviously we somehow managed to see cocks
                    setBabeSafeTimer(null)

                    // If we came from a TRIGGER event
                    if (event.type === 'TRIGGER') {
                        // Remove text prompt if there is one
                        if (textPrompt !== null) {
                            setTextPrompt(null)
                        }
                        // Show 100% a cock taunt
                        let taunt = getRandomLine(baseLines.cockTaunts)
                        showTaunt(taunt, cockDuration)
                        // Decrease the cock chance
                        let decrease = getRndTime(gameData.defaultCockChanceDecreaseAfterTriggerMinimum, gameData.defaultCockChanceDecreaseAfterTriggerMaximum, 0)
                        setCockTriggerChance((prevValue) => prevValue - decrease)
                        // Take a hit to our masculinity
                        decreaseMasculinity(gameData.defaultMasculinityCockDecrease)
                    }

                    // Should we start the cock timer?
                // TODO: More conditions here if needed!
                    if (!forceLoopOverride) {
                        // Only start the cock timer if there isn't already one running
                        if (cockDuration === null) {
                            setCockTimer(0)
                            setCockDuration(getRndTime(gameData.defaultCockDurationMinimum, gameData.defaultCockDurationMaximum, 1))
                        }
                    }

                    let clips = baseClips.cocks;
                    // If our masculinity is low enough, we also can also show shots instead of only cocks
                    if (masculinity <= gameData.defaultMasculinityShotsThreshold) {
                        clips = clips.concat(baseClips.shots)
                    }
                    // Include cock clips from xpacs if we have them unlocked
                    let xpacs = getXpacClips("cocks")
                    // Filter xpac clips for unlocked clips only
                    let filteredXpacs = xpacs.filter(x => isClipIdUnlocked(unlockedCards, x.id))
                    clips = clips.concat(filteredXpacs)


                    // Get cock exclude tags from prefs
                    let excludeTags = prefs.getPref(prefs.PREF_TAGS, {
                        exclude: [], only: []
                    }).exclude
                    excludeTags = excludeTags.filter((t) => {
                        return baseTags.cocks.filter(b => b.id === t).length > 0
                    })
                    // Get cock only tags from prefs
                    let onlyTags = prefs.getPref(prefs.PREF_TAGS, {
                        exclude: [], only: []
                    }).only
                    onlyTags = onlyTags.filter((t) => {
                        return baseTags.cocks.filter(b => b.id === t).length > 0
                    })

                    // Show random cock or shot clip
                    let clip = getRandomClip(clips, (c) => {
                        // filter last played clip
                        let previousClip = c.id !== prevClip.id
                        return previousClip
                    }, excludeTags, onlyTags)

                    // -
                    setActiveClip(clip)

                    // Exit
                    return () => {
                        console.log('Exited "cock" gamestate.', gamestate)
                    }
                }
            },

            // Gameover gamestate
            gameover: {
                on: {
                    CLIPEND: 'gameover',
                    RESTART: 'pre'
                },
                effect({ event }) {
                    
                    // Enter
                    console.log('Entered "gameover" gamestate.', gamestate)

                    // show random gameover clip
                    let clip = getRandomClip(baseClips.gameover, (c) => { return c.id !== prevClip.id })
                    // Allow the same clip be played again
                    if (activeClip.id === clip.id) {
                        refVidMain.current.seekTo(0)
                    } else {
                        setActiveClip(clip)
                    }

                    if (event.type !== 'CLIPEND') {
                        // Show gameover question
                        let q = chooseQuestion(baseQuestions.system.gameoverQuestion)
                        // restart choice callback
                        q.choices[0].onChoice = () => {
                            sendGamestate('RESTART')
                        }
                        // exit choice callback
                        q.choices[1].onChoice = () => {
                            requestGameExit()
                        }
                        setQuestion(q)

                        setBabeSafeTimer(null)
                        setCountdownTimer(null)
                        setClipPlaybackRate(1)
                    }


                    // Exit
                    return () => {
                        console.log('Exited "gameover" gamestate.', gamestate)
                        // TODO: Processing on exit here
                    }
                }
            },
        },
    })


    // Debug monitor methods
    // ---------
    useEffect(() => {
        if (debugMonitor !== null) {
            prefs.setPref(prefs.PREF_DEBUG, debugMonitor)
        }
    }, [debugMonitor])


    // Game data
    // ---------
    useEffect(() => {
        if (gameData === null) return;
        // Apply game data to states
        setTauntChance(gameData.startTauntChance)
        setMasculinity(gameData.startMasculinity)

        console.log("GameData applied.", gameData)
    }, [gameData])


    // Pausing
    // ---------
    useEffect(() => {
        if (!initialized) return;
        if (refVidBg.current === null) return;
        if (refVidMain === null) return;

        if (gamePaused === true) {
            console.log("Game was paused.")
            // Suspend timers
            clearInterval(refBabeSafeTimerInterval.current)
            clearInterval(refCockTimerInterval.current)
            clearInterval(refCountdownTimerInterval.current)
            clearInterval(refTauntTimerInterval.current)
        } else {
            console.log("Game was resumed.")
            // Todo
        }
    }, [gamePaused, initialized])


    // Send event out if cock chance updates
    // ---------
    useEffect(() => {

        // Limit chance between 0 and 100 percent
        if (cockTriggerChance > 100) {
             setCockTriggerChance(100)
             return
        } else if (cockTriggerChance < 0) {
            setCockTriggerChance(0)
            return
        }

        onUpdateCockChance(cockTriggerChance)

    }, [cockTriggerChance, onUpdateCockChance])

    // Clips methods
    // ----------
    function filterClipTags(data = [], tagsExcluded = [], tagsOnly = []) {
        var result = data

        // Filter out excluded tags
        tagsExcluded.forEach(t => {
            result = data.filter((c) => !c.tags.includes(t))
        })

        // Filter out clips that don't include 'only' tags
        tagsOnly.forEach(t => {
            result = data.filter((c) => c.tags.includes(t))
        })

        return result
    }

    function getRandomClip(data, filter = null, tagsExcluded = [], tagsOnly = []) {
        // Copy data
        //let list = data
        let list = filterClipTags(data, tagsExcluded, tagsOnly)

        // Apply filter if necessary
        if (filter !== null) {
            list = list.filter(filter)
        }
        
        // Choose random element and return as ClipData
        let result = list[Math.floor(Math.random() * list.length)]
        return new ClipData(result.id, result.file, result.path, ('triggerTime' in result) ? result.triggerTime : null)
    }

    function showClip(id = null) {
        if (id === null) return;

        let clips = getBaseClips().concat(getXpacClips())
        let result = clips.find((c) => {
            return c.id === id
        })
        if (result === null) {
            let a = baseClips.babes[0]
            let b = new ClipData(a.id, a.file, a.path, a.triggerTime)
            setActiveClip(b)
        }
        let clip = new ClipData(result.id, result.file, result.path, result.triggerTime)

        setActiveClip(clip)
    }

    // Player methods
    // ----------
    const onPlayerClipStarted = () => {
        
        console.log("Playing video clip.", activeClip)

        // Update max played time
        setClipTimeMax(refVidMain.current?.getDuration())

        // Update trigger time
        setClipTriggerChecked(false)
        setClipTriggerTime(activeClip?.triggerTime)

        // Play the background video as well
        refVidBg.current.play()
    }

    const onPlayerClipProgressed = (e) => {

        // Update current played time
        setClipTimeCurrent(e.playedSeconds)

        /*  Reset checked trigger if we're somewhere at the start of the clip
            The reason we don't do this in onPlayerClipStarted() is because those are not called
            if we loopOverride! */
        if (e.playedSeconds < 0.1 && clipTriggerChecked === true) setClipTriggerChecked(false)

        // Check if we've a triggerTime and if we've reached the current triggerTime yet
        if (clipTriggerTime != null && e.playedSeconds >= clipTriggerTime) {
            // Only do something if we haven't checked for the trigger yet
            if (!clipTriggerChecked) {
                // Check if we CAN trigger something
                if (canTrigger()) {
                    // Trigger now
                    console.log("Video clip triggered at:", e.playedSeconds)
                    sendGamestate('TRIGGER')
                } else {
                    // Add some currency
                    var increaseCurrency = Math.floor(Math.random() * (gameData.defaultCurrencyAddBabeSuccessMax - gameData.defaultCurrencyAddBabeSuccessMin + 1)) + gameData.defaultCurrencyAddBabeSuccessMin
                    // increase currency by current cock chance (high danger = higher reward)
                    var currencyDanger = Math.floor(increaseCurrency * (cockTriggerChance / 100))
                    //console.log("currency = " + increaseCurrency + "+" + currencyDanger)
                    onAddCurrency(increaseCurrency + currencyDanger)
                    // Add some masculinity if chance allows it
                    if (getChance(gameData.defaultMAsculinityBoobsIncreaseChance)) {
                        increaseMasculinity(gameData.defaultMasculinityBoobsIncrease)
                    }
                }
                // We've checked for trigger now
                setClipTriggerChecked(true)
            }
        }
    }

    const onPlayerClipEnded = () => {
        
        console.log("Video clip ended.", activeClip)

        setPrevClip(activeClip)
        sendGamestate('CLIPEND')
    }

    const onPlayerClipSeeked = (e) => {
        refVidBg.current.currentTime = e
        console.log("Video clip seeked to:", e)
    }

    const onPlayerClipPlaybackRateChanged = (e) => {
        refVidBg.current.playbackRate = e
        console.log("Video clip playback rate set to:", refVidBg.current.playbackRate)
    }

    // Previous clips lists methods
    // ---------

    function addPrevBabe(babeClip) {
        let result = prevBabes
        if (result.length > 1) {
            result = result.slice(-1)
        }
        result.push(babeClip)
        setPrevBabes(result)
    }

    // Trigger methods
    // ---------

    function canTrigger() {

        // We can't trigger anything while we're in forceLoopOverride
        if (forceLoopOverride) return false

        // We can't trigger anything either if we're not in the right gamestate
        if (gamestate.value !== 'babe') return false

        // NO chance AT ALL if there's a safe timer running
        if (babeSafeTimer !== null || babeSafeTimer > 0) return false

        // TODO: We can factor in other chances here
        return getChance(cockTriggerChance)
    }

    // Timer effects
    // ---------

    // Cock timer
    const refCockTimerInterval = useRef(null)
    useEffect(() => {
        if (!gamePaused) {
            // timer interval
            refCockTimerInterval.current =
                ((cockTimer !== null && cockDuration !== null) && cockTimer < cockDuration) &&
                setInterval(() => setCockTimer(cockTimer + 0.1), 100)

            // check if we've reached the timer duration
            if ((cockTimer !== null && cockDuration !== null) && cockTimer >= cockDuration) {
                console.log("cockTimer time reached cockDuration.", refCockTimerInterval.current)
                sendGamestate('TIMEOUT')
                clearInterval(refCockTimerInterval.current)
            }

            return () => {
                clearInterval(refCockTimerInterval.current)
            }
        } else {
            clearInterval(refCockTimerInterval.current)
        }
    }, [cockDuration, cockTimer, gamePaused, sendGamestate])

    // Babe safe timer
    const refBabeSafeTimerInterval = useRef(null)
    useEffect(() => {
        if (!gamePaused) {
            // timer interval
            refBabeSafeTimerInterval.current =
                (babeSafeTimer !== null && babeSafeTimer > 0) &&
                setInterval(() => setBabeSafeTimer(babeSafeTimer - 0.1), 100)
            onUpdateSafeTimer(babeSafeTimer)
            
            // Check if timer reached zero
            if (babeSafeTimer !== null && babeSafeTimer <= 0) {
                setBabeSafeTimer(null)
                clearInterval(refBabeSafeTimerInterval.current)
            }

            return () => {
                clearInterval(refBabeSafeTimerInterval.current)
            }
        } else {
            clearInterval(refBabeSafeTimerInterval.current)
        }
    }, [babeSafeTimer, gamePaused])

    // Countdown timer
    function startCountdown(time = null, onEnded = () => {}) {
        if (time === null) {
            setCountdownTimer(null)
            setOnCountdownEnded(null)
        } else {
            setCountdownTimer(time)
            setOnCountdownEnded(() => () => onEnded())
        }
    }
    const refCountdownTimerInterval = useRef(null)
    useEffect(() => {
        if (!gamePaused) {
            // timer interval
            refCountdownTimerInterval.current =
                (countdownTimer !== null && countdownTimer > 0) &&
                setInterval(() => setCountdownTimer(countdownTimer - 0.1), 100)

            // Check if timer reached zero
            if (countdownTimer !== null && countdownTimer <= 0) {
                onCountdownEnded()
                startCountdown()
                clearInterval(refCountdownTimerInterval.current)
            }

            return () => {
                clearInterval(refCountdownTimerInterval.current)
            }
        } else {
            clearInterval(refCountdownTimerInterval.current)
        }
    }, [countdownTimer, onCountdownEnded, gamePaused])
    
    // Taunt timer effect
    const refTauntTimerInterval = useRef(null)
    useEffect(() => {
        if (!gamePaused) {
            // timer interval
            refTauntTimerInterval.current =
                (tauntTimer !== null && tauntTimer > 0) &&
                setInterval(() => setTauntTimer(tauntTimer - 0.1), 100)

            // Check if timer reached zero
            if (tauntTimer !== null && tauntTimer <= 0) {
                // Clean up text prompt if we don't have a question active
                setTextPrompt(null)
                setTauntTimer(null)
                clearInterval(refTauntTimerInterval.current)
            }

            return () => {
                clearInterval(refTauntTimerInterval.current)
            }
        } else {
            clearInterval(refTauntTimerInterval.current)
        }
    }, [tauntTimer, gamePaused])
    

    // Text prompt & Question
    // ----------
    useEffect(() => {
        // If we have a question set
        if (question !== null) {
            // Set the text prompt, just override if necessary (questions are more important than flavour text!)
            setTextPrompt(question.questionText)
        } else {
            // We may want to prevent cleanup in rare cases(i.e. when setting a new prompt right before)
            if (preventQuestionPromptCleanup === false) {
                // Cleanup text prompt
                setTextPrompt(null)
            }
        }
        
    }, [question, preventQuestionPromptCleanup])


    function getRandomLine(data, filter = null) {
        // Copy data
        let list = data
        // Apply filter if necessary
        if (filter !== null) {
            list = list.filter(filter)
        }
        
        // Return random element
        return list[Math.floor(Math.random() * list.length)]
    }

    function chooseQuestion(data) {
        let text = getRandomLine(data.text)
        let choices = []
        data.choices.forEach(element => {
            choices.push(new ChoiceData(element, () => {}))
        });
        return new QuestionData(text, choices)
    }

    function canTaunt() {
        // TODO: We can factor in other chances here
        return getChance(tauntChance)
    }

    function showTaunt(text = null, duration = null) {
        // Don't show a taunt if we have a question active
        if (question === null) {
            setTextPrompt(text)
            setTauntTimer(duration)
        } else {
            console.log("Could not show taunt because a question is active..", text, duration, question)
        }
    }


    // Masculinity
    // ---------
    // Send out event when masculinity changes
    useEffect(() => {
        onUpdateMasculinity(masculinity)
        checkGameOver()
    }, [masculinity, onUpdateMasculinity])

    function increaseMasculinity(increase) {
        let result = clamp(masculinity + increase, 0, 100)
        setMasculinity(result)
    }

    function decreaseMasculinity(decrease) {
        let result = clamp(masculinity - decrease, 0, 100)
        setMasculinity(result)
    }

    function checkGameOver() {
        if (masculinity <= 0) {
            sendGamestate('GAMEOVER')
        }
    }


    // Util
    // ---------

    const getRndTime = (min, max, fractionDigits = 1) => {
        let power = Math.pow(10, Math.floor(fractionDigits))
        let minimum = Math.floor(min * power)
        let maximum = Math.floor(max * power)

        let result = Math.floor(Math.random() * (maximum - minimum + 1)) + minimum
        return result / power
    }

    const getChance = (percentage) => {
        let p = percentage / 100
        if (p < 0) p = 0
        if (p > 1) p = 1
        let r = Math.random()

        //console.log("chance calculation input (" + percentage + ") | result = " + r)
        
        return r <= p
    }

    const remap = (
        value,
        srcMin,
        srcMax,
        destMin = 0,
        destMax = 1,
    ) => {
        return destMin + ((value - srcMin) / (srcMax - srcMin)) * (destMax - destMin)
    }

    const clamp = (value, min, max) => {
        let result = value
        if (result > max) result = max
        if (result < min) result = min
        return result
    }


    /* Swipe gesture
    ------------------------------------------------- 
        with help from: https://github.com/sriechers/react-spring-swipe-stack/tree/main
                and:    https://github.com/pmndrs/use-gesture?tab=readme-ov-file
    */

    const canSwipe = () => {
        /* We only want to be able to swipe when: 
                - we're showing a babe
                - there's no countdown running
                - only before the boobs drop / before trigger time
        */
        return  gamestate.value === 'babe' &&
                countdownTimer === null &&
                clipTriggerChecked === false;
    }

    const [{ x }, springApi] = useSpring(() => ({ x: 0 }))
    /*const springConfigs = {
        active: config.stiff,
        flyOut: config.molasses,
        default: config.slow,
        reset: config.gentle
    }*/

    function swipeOnBabe(xDir) {

        if (refAnimFlyOut.current === true) {
            return
        }
        refAnimFlyOut.current = true

        springApi.start({
            from: {
                x: x
            },
            to: {
                x: window.innerWidth * xDir
            },
            onRest: () => {
                springApi.set({ x: window.innerWidth * (-xDir)})
                refAnimFlyOut.current = false
                sendGamestate('SWIPE')
            }
        })
    }
    
    const bindGesture = useDrag(
        ({
            active,
            movement: [mx, my],
            direction: [xDir],
            velocity: [vx],
        }) => {

            // Only allow babes to be swiped, and only if we don't have a countdown timer
            if (!canSwipe()) {
                springApi.start({ x: 0 })
                refAnimFlyOut.current = false
                return;
            }
            // Don't allow gesture anymore if video already flies out
            if (refAnimFlyOut.current === true) return

            // If you flick hard enough it should trigger the video to fly out
            const maxVelocity = 1.8   // TODO: We should get this from user settings!!!
            const trigger = vx > maxVelocity

            // Animate drag
            springApi.start({ x: active ? mx : 0 })

            // If button/finger's up and trigger velocity is reached, we flag the video ready to fly out
            if (!active && trigger) {
                swipeOnBabe(xDir)
                //refAnimFlyOut.current = true  // we do that in swipeOnBabe() now!
            }
        }
    )


    /* MODALS */
    const [modalQuitGame, setModalQuitGame] = useState(false)
    const confirmQuitGame = () => {
        requestGameExit()
        setModalQuitGame(false)
    }
    const cancelQuitGame = () => {
        setModalQuitGame(false)
    }



    // RENDER
    // ---------
    return(
        <div className={styles.container}>

            {/* Control Menu */}
            <Controls gamePaused={gamePaused}
                    onRequestPause={()=>setGamePaused(!gamePaused)}
                    onRequestFullscreen={requestFullscreenToggle}
                    fullscreen={fullscreen}
                    overlayEnabled={overlayFx}
                    onRequestOverlayToggle={()=>setOverlayFx(!overlayFx)} />

            {/* PAUSE MENU */}
            <div className={styles.menu} style={{display: gamePaused ? 'flex' : 'none'}}>
                
                {/* TODO: Make stylish menu */}
                <button onClick={()=>setGamePaused(false)}>Resume</button>
                <button onClick={requestSettings}>Settings</button>
                <button onClick={()=>setModalQuitGame(true)}>Exit to main menu</button>
                
            </div>

            {/* GAME */}
            <div className={styles.game} style={{display: gamePaused ? 'none' : 'flex'}}>

                {/* Background video */}
                <video className={styles.videoBg}
                    ref={refVidBg}
                    src={activeClip.filePath}
                    loop playsInline muted
                    controls={false}><source type="video/webm"></source></video>

                
                <div className={styles.swipe} {...bindGesture()} />


                {/* Main video */}
                <div className={styles.videoContainerMain}>
                    <animated.div className={styles.videoMain} style={{ x }}>
                        <ReactPlayer ref={refVidMain}
                                url={activeClip.filePath}
                                loop={forceLoopOverride}
                                
                                playbackRate={clipPlaybackRate}

                                onStart={onPlayerClipStarted}
                                onProgress={onPlayerClipProgressed}
                                onEnded={onPlayerClipEnded}
                                onSeek={onPlayerClipSeeked}
                                onPlaybackRateChange={onPlayerClipPlaybackRateChanged}

                                playing={!gamePaused} playsinline muted
                                onPause={()=>refVidBg.current?.pause()}
                                onPlay={()=>refVidBg.current?.play()}
                                volume={0}
                                progressInterval={10}
                                controls={false}
                                width="100%"
                                height="100%" />
                    </animated.div>
                </div>

                {/* Overlay Fx */}
                <OverlayFx enabled={overlayFx} />

                {/* Swipe controls */}
                {canSwipe() &&
                <div className={styles.swipeControls}>
                    <SwipeButton direction='left' onClick={() => {
                            //console.log("TEST", refAnimFlyOut.current)
                            swipeOnBabe(-1)
                        }} />
                    <SwipeButton direction='right' onClick={() => swipeOnBabe(1)} />
                </div>}


                {/* Content area */}
                <div className={styles.area}>

                    {/* Top half */}
                    <div className={styles.areaHalf}>
                        <div className={styles.areaTopSafe}>
                            {/* Countdown */}
                            <Countdown time={countdownTimer} />
                        </div>
                    </div>
                    
                    {/* Bottom half */}
                    <div className={styles.areaHalf}>
                        <div className={styles.areaBottomSafe}>
                            {/* Text prompt */}
                            <TextPrompt text={textPrompt} />
                            {/* Choices */}
                            <ChoicesContainer question={question} />
                        </div>
                    </div>

                </div>

                
                {/* Debug Monitor */}
                { debugMode === true && <DebugMonitor enabled={debugMonitor}
                            onToggle={()=>setDebugMonitor(!debugMonitor)}
                            
                            overlayFx={overlayFx}
                            onOverlayFx={()=>setOverlayFx(!overlayFx)}
                            gamestate={gamestate}
                            sendGamestate={sendGamestate}
                            
                            forceLoopOverride={forceLoopOverride}
                            onForceLoopOverride={(e)=>setForceLoopOverride(e.target.checked)}
                            activeClip={activeClip}
                            prevClip={prevClip}
                            clipTimeCurrent={clipTimeCurrent}
                            clipTimeMax={clipTimeMax}
                            clipPlaybackRate={clipPlaybackRate}
                            onPlaybackRate={(v)=>setClipPlaybackRate(v / 100)}
                            
                            clipTriggerChecked={clipTriggerChecked}
                            clipTriggerTime={clipTriggerTime}
                            cockDuration={cockDuration}
                            cockTimer={cockTimer}
                            cockTriggerChance={cockTriggerChance}
                            onCockTriggerChance={(v)=>setCockTriggerChance(parseInt(v, 10))}
                            babeSafeTimer={babeSafeTimer}
                            clips={/*[].concat(baseClips.babes, baseClips.cocks, baseClips.shots)*/getBaseClips().concat(getXpacClips())}
                            onClipSelected={(e)=>showClip(e.target.value)}
                            
                            onDecreaseMasc={(v)=>decreaseMasculinity(v)}
                            onIncreaseMasc={(v)=>increaseMasculinity(v)}
                            onAddCurrency={onAddCurrency}
                            onRemoveCurrency={onRemoveCurrency} /> }
            </div>


            {/* Quit Game MODAL */}
            {modalQuitGame && <Modal>
                <Dialog title='Exit Game'
                        msg={<span>Exiting the game will return you back to the main menu. <b>Are you sure?</b></span>}
                        onConfirm={confirmQuitGame}
                        onCancel={cancelQuitGame} />
            </Modal>}

        </div>
    );
}


export default GameView